import React, { useCallback } from 'react'
import { DatePicker } from 'antd'
import dayjs from 'dayjs'
import type { CustomFilterProps } from 'ag-grid-react'
import { useGridFilter } from 'ag-grid-react'

const { RangePicker } = DatePicker

interface DateRangeModel {
  filterType: 'date'
  type: 'inRange'
  dateFrom: string
  dateTo: string
}

const DateRangeColumnFilter: React.FC<CustomFilterProps> = ({ model, onModelChange }) => {
  const doesFilterPass = useCallback(() => true, [])

  useGridFilter({ doesFilterPass })

  const value: [dayjs.Dayjs, dayjs.Dayjs] | null =
    model?.dateFrom && model?.dateTo ? [dayjs(model.dateFrom), dayjs(model.dateTo)] : null

  const handleChange = (dates: [dayjs.Dayjs | null, dayjs.Dayjs | null] | null) => {
    if (dates?.[0] && dates?.[1]) {
      const newModel: DateRangeModel = {
        filterType: 'date',
        type: 'inRange',
        dateFrom: dates[0].format('YYYY-MM-DD'),
        dateTo: dates[1].format('YYYY-MM-DD')
      }
      onModelChange(newModel)
    } else {
      onModelChange(null)
    }
  }

  return (
    <div style={{ padding: 8, width: 260 }}>
      <RangePicker
        value={value}
        onChange={handleChange}
        format="DD.MM.YYYY"
        style={{ width: '100%' }}
        allowClear
        getPopupContainer={() => document.body}
        classNames={{ popup: { root: 'ag-custom-component-popup' } }}
      />
    </div>
  )
}

export default DateRangeColumnFilter
